import React, { Fragment } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import styled from 'src/ui/library/styled';
import styles from './styles';

/*
  Refactoring Idea:
    <List
      items=['Inbox', 'Sent', 'Draft']
      // or react components
      items=[<div>ok</div>, <div>ok 2</div>, <div>ok 3</div>]
      // leave it up to the developer to handle filtering      
      onFilter={(data) => data.filter(value !== filterValue) }
      selected={2}
      onClick={(selectedIndex, value) => {}}
      virtualized
    />

*/

class ListBase extends React.Component {
  render() {
    const { config, classes, isMobile, isTablet, onClick, subheader } = this.props;

    // const subheaderClass = {
    //   root: {
    //     fontWeight: 'bold',
    //   },
    // };

    return (
      <Fragment>
        <List
          subheader={isMobile || isTablet ? <ListSubheader>{subheader}</ListSubheader> : null}
          classes={{
            root: classes.root,
          }}>
          {config.map((each, i) => {
            return (
              <ListItem
                button
                classes={{
                  root: each.className,
                }}
                key={i}
                onClick={onClick.bind(null, each.onClickAction)}
                selected={each.selected}>
                <ListItemText classes={each.classes} key={i} primary={each.title} />
              </ListItem>
            );
          })}
        </List>
      </Fragment>
    );
  }
}

export default styled(ListBase)(styles);
